import { Observable } from 'rxjs';

import { AuthPayload, AuthState } from '../models/auth.model';

export abstract class AuthUsecase {
  abstract get authState$(): Observable<AuthState>;
  abstract get token$(): Observable<string>;
  abstract get payload$(): Observable<AuthPayload>;

  abstract signIn(username: string, password: string): Observable<never>;
  abstract confirmSignIn(code: string): Observable<never>;
  abstract completeNewPassword(password: string): Observable<never>;
  abstract signOut(): Observable<never>;
  abstract forgotPassword(username: string): Observable<never>;
  abstract forgotPasswordSubmit(username: string, code: string, password: string): Observable<never>;
  abstract changePassword(oldPassword: string, newPassword: string): Observable<never>;
  abstract verifyAuthFactor(phoneNumber: string): Observable<never>;
  abstract verifyAuthFactorSubmit(code: string): Observable<never>;
  abstract deleteAuthFactor(): Observable<never>;
  abstract refreshCache(): Observable<never>;
  abstract setAuthState(state: AuthState): void;
}
